module.exports = __webpack_public_path__ + "img/signature.ca7dbf7d.jpg";